// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e8f3a3a3","455":"bb49f2a9","977":"75961c8d"}[chunkId] + ".chunk.js";
};